import React from 'react'

import ChatEntry from './entry'
import commonCss from '~/core/css'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { getSessionChat } from '~/selectors/session-details'

const Container = styled.ul`
  ${commonCss.resetBoxProps};
  list-style-type: none;

  overflow-y: auto;
`

const ChatList = ({ hideTimestamps, id, chatListId, tabbable }) => {
  const chat = useSelector(getSessionChat(id))

  return (
    <Container id={chatListId}>
      {chat.map((entry, index) => {
        const sameAuthorAsPreviousMessage = index > 0 && chat[index].jid === chat[index - 1].jid
        const hideTimestamp = chat[index].jid === chat[index + 1]?.jid || hideTimestamps

        return (
          <ChatEntry
            entry={entry}
            hideInfo={sameAuthorAsPreviousMessage}
            hideTimestamp={hideTimestamp}
            key={`${index}-${entry.timestamp}`}
          />
        )
      })}
    </Container>
  )
}

export default ChatList
